export default __webpack_public_path__ + "static/media/hand_info_section.32c68447.png";